import { Client, Account, Storage, ID, Permission, Role } from 'appwrite';
import { env } from '../env';

const client = new Client();
client
  .setEndpoint(env.appwriteEndpoint)
  .setProject(env.appwriteProjectId);

const account = new Account(client);
const storage = new Storage(client);

export { client, account, storage, ID , Permission, Role};
